/** @format */

import styled from '@emotion/styled';

export const StyledTrFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
